module.exports = __webpack_public_path__ + "static/media/hard_dollars_2.4a98acf8.png";